// @ts-nocheck

/**
 * YPM_DESIGN_SRV
 * Design  ## Entity Data Model ![ER Diagram](https://yuml.me/diagram/class/[Design{bg:orange}],[DesignSet{bg:dodgerblue}]++-*>[Design])  ### Legend ![Legend](https://yuml.me/diagram/plain;dir:TB;scale:60/class/[External.Type{bg:whitesmoke}],[ComplexType],[EntityType{bg:orange}],[EntitySet/Singleton/Operation{bg:dodgerblue}])
 *
 * The version of the OpenAPI document: 0001
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { Design } from '../model/models';
import { ModelError } from '../model/models';
import { Wrapper } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class DesignSetService {

    protected basePath = 'https://dkasub.corp.lego.com:1443/sap/opu/odata/sap/YPM_DESIGN_SRV';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }



    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Get entity from DesignSet by key
     * @param designId Material Number   Alphanumeric key uniquely identifying the material.
     * @param $select Select properties to be returned, see [Select](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;68)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public designSetDesignIdGet(designId: string, $select?: Array<'designId' | 'authorizationGroup' | 'designDescription' | 'superDesign' | 'makeBuy' | 'createdOn' | 'qa40c' | 'qa20c' | 'responsibleUser' | 'responsibleName' | 'designer' | 'usability' | 'usabilityText' | 'designerName' | 'launchiID' | 'launchDescription' | 'globalLaunchDate'>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Design>;
    public designSetDesignIdGet(designId: string, $select?: Array<'designId' | 'authorizationGroup' | 'designDescription' | 'superDesign' | 'makeBuy' | 'createdOn' | 'qa40c' | 'qa20c' | 'responsibleUser' | 'responsibleName' | 'designer' | 'usability' | 'usabilityText' | 'designerName' | 'launchiID' | 'launchDescription' | 'globalLaunchDate'>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Design>>;
    public designSetDesignIdGet(designId: string, $select?: Array<'designId' | 'authorizationGroup' | 'designDescription' | 'superDesign' | 'makeBuy' | 'createdOn' | 'qa40c' | 'qa20c' | 'responsibleUser' | 'responsibleName' | 'designer' | 'usability' | 'usabilityText' | 'designerName' | 'launchiID' | 'launchDescription' | 'globalLaunchDate'>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Design>>;
    public designSetDesignIdGet(designId: string, $select?: Array<'designId' | 'authorizationGroup' | 'designDescription' | 'superDesign' | 'makeBuy' | 'createdOn' | 'qa40c' | 'qa20c' | 'responsibleUser' | 'responsibleName' | 'designer' | 'usability' | 'usabilityText' | 'designerName' | 'launchiID' | 'launchDescription' | 'globalLaunchDate'>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (designId === null || designId === undefined) {
            throw new Error('Required parameter designId was null or undefined when calling designSetDesignIdGet.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($select) {
            queryParameters = this.addToHttpParams(queryParameters,
                $select.join(COLLECTION_FORMATS['csv']), '$select');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<Design>(`${this.configuration.basePath}/DesignSet('${encodeURIComponent(String(designId))}')`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get entities from DesignSet
     * @param $top Show only the first n items, see [Paging - Top](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;66)
     * @param $skip Skip the first n items, see [Paging - Skip](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;65)
     * @param $filter Filter items by property values, see [Filtering](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;64)
     * @param $inlinecount Include count of items, see [Inlinecount](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;67)
     * @param $orderby Order items by property values, see [Sorting](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;65)
     * @param $select Select properties to be returned, see [Select](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;68)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public designSetGet($top?: number, $skip?: number, $filter?: string, $inlinecount?: 'allpages' | 'none', $orderby?: Array<'designId' | 'designId desc' | 'authorizationGroup' | 'authorizationGroup desc' | 'designDescription' | 'designDescription desc' | 'superDesign' | 'superDesign desc' | 'makeBuy' | 'makeBuy desc' | 'createdOn' | 'createdOn desc' | 'qa40c' | 'qa40c desc' | 'qa20c' | 'qa20c desc' | 'responsibleUser' | 'responsibleUser desc' | 'responsibleName' | 'responsibleName desc' | 'designer' | 'designer desc' | 'usability' | 'usability desc' | 'usabilityText' | 'usabilityText desc' | 'designerName' | 'designerName desc' | 'launchiID' | 'launchiID desc' | 'launchDescription' | 'launchDescription desc' | 'globalLaunchDate' | 'globalLaunchDate desc'>, $select?: Array<'designId' | 'authorizationGroup' | 'designDescription' | 'superDesign' | 'makeBuy' | 'createdOn' | 'qa40c' | 'qa20c' | 'responsibleUser' | 'responsibleName' | 'designer' | 'usability' | 'usabilityText' | 'designerName' | 'launchiID' | 'launchDescription' | 'globalLaunchDate'>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Wrapper>;
    public designSetGet($top?: number, $skip?: number, $filter?: string, $inlinecount?: 'allpages' | 'none', $orderby?: Array<'designId' | 'designId desc' | 'authorizationGroup' | 'authorizationGroup desc' | 'designDescription' | 'designDescription desc' | 'superDesign' | 'superDesign desc' | 'makeBuy' | 'makeBuy desc' | 'createdOn' | 'createdOn desc' | 'qa40c' | 'qa40c desc' | 'qa20c' | 'qa20c desc' | 'responsibleUser' | 'responsibleUser desc' | 'responsibleName' | 'responsibleName desc' | 'designer' | 'designer desc' | 'usability' | 'usability desc' | 'usabilityText' | 'usabilityText desc' | 'designerName' | 'designerName desc' | 'launchiID' | 'launchiID desc' | 'launchDescription' | 'launchDescription desc' | 'globalLaunchDate' | 'globalLaunchDate desc'>, $select?: Array<'designId' | 'authorizationGroup' | 'designDescription' | 'superDesign' | 'makeBuy' | 'createdOn' | 'qa40c' | 'qa20c' | 'responsibleUser' | 'responsibleName' | 'designer' | 'usability' | 'usabilityText' | 'designerName' | 'launchiID' | 'launchDescription' | 'globalLaunchDate'>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Wrapper>>;
    public designSetGet($top?: number, $skip?: number, $filter?: string, $inlinecount?: 'allpages' | 'none', $orderby?: Array<'designId' | 'designId desc' | 'authorizationGroup' | 'authorizationGroup desc' | 'designDescription' | 'designDescription desc' | 'superDesign' | 'superDesign desc' | 'makeBuy' | 'makeBuy desc' | 'createdOn' | 'createdOn desc' | 'qa40c' | 'qa40c desc' | 'qa20c' | 'qa20c desc' | 'responsibleUser' | 'responsibleUser desc' | 'responsibleName' | 'responsibleName desc' | 'designer' | 'designer desc' | 'usability' | 'usability desc' | 'usabilityText' | 'usabilityText desc' | 'designerName' | 'designerName desc' | 'launchiID' | 'launchiID desc' | 'launchDescription' | 'launchDescription desc' | 'globalLaunchDate' | 'globalLaunchDate desc'>, $select?: Array<'designId' | 'authorizationGroup' | 'designDescription' | 'superDesign' | 'makeBuy' | 'createdOn' | 'qa40c' | 'qa20c' | 'responsibleUser' | 'responsibleName' | 'designer' | 'usability' | 'usabilityText' | 'designerName' | 'launchiID' | 'launchDescription' | 'globalLaunchDate'>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Wrapper>>;
    public designSetGet($top?: number, $skip?: number, $filter?: string, $inlinecount?: 'allpages' | 'none', $orderby?: Array<'designId' | 'designId desc' | 'authorizationGroup' | 'authorizationGroup desc' | 'designDescription' | 'designDescription desc' | 'superDesign' | 'superDesign desc' | 'makeBuy' | 'makeBuy desc' | 'createdOn' | 'createdOn desc' | 'qa40c' | 'qa40c desc' | 'qa20c' | 'qa20c desc' | 'responsibleUser' | 'responsibleUser desc' | 'responsibleName' | 'responsibleName desc' | 'designer' | 'designer desc' | 'usability' | 'usability desc' | 'usabilityText' | 'usabilityText desc' | 'designerName' | 'designerName desc' | 'launchiID' | 'launchiID desc' | 'launchDescription' | 'launchDescription desc' | 'globalLaunchDate' | 'globalLaunchDate desc'>, $select?: Array<'designId' | 'authorizationGroup' | 'designDescription' | 'superDesign' | 'makeBuy' | 'createdOn' | 'qa40c' | 'qa20c' | 'responsibleUser' | 'responsibleName' | 'designer' | 'usability' | 'usabilityText' | 'designerName' | 'launchiID' | 'launchDescription' | 'globalLaunchDate'>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($top !== undefined && $top !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>$top, '$top');
        }
        if ($skip !== undefined && $skip !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>$skip, '$skip');
        }
        if ($filter !== undefined && $filter !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>$filter, '$filter');
        }
        if ($inlinecount !== undefined && $inlinecount !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>$inlinecount, '$inlinecount');
        }
        if ($orderby) {
            queryParameters = this.addToHttpParams(queryParameters,
                $orderby.join(COLLECTION_FORMATS['csv']), '$orderby');
        }
        if ($select) {
            queryParameters = this.addToHttpParams(queryParameters,
                $select.join(COLLECTION_FORMATS['csv']), '$select');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<Wrapper>(`${this.configuration.basePath}/DesignSet`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
